import { render, staticRenderFns } from "./ManageTransactionsReport.vue?vue&type=template&id=45924f9e"
import script from "./ManageTransactionsReport.vue?vue&type=script&lang=js"
export * from "./ManageTransactionsReport.vue?vue&type=script&lang=js"
import style0 from "./ManageTransactionsReport.vue?vue&type=style&index=0&id=45924f9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports